export default {
    en: {
        Thank: {
            done: "Your order is placed successfully",
            orderNum: "Your order number is: ",
            orderDetails: "Thank you for your order from our site. Your order will be delivered as soon as possible.",
            printInvoice: "Print Invoice",
            contact: "Contact",
            home: "Home Page",
            returnToProduct: "Product Page",
            PageNotFound: "Page not found",
            PageNotFoundDesc: "we couldn't find the page you looking for.",
            PaymentFailed: "Payment failed",
        },
    },
    ar: {
        Thank: {
            done: "تم تنفيذ طلبك بنجاح",
            orderNum: "رقم الطلب الخاص بك: ",
            orderDetails: "شكرا لك لطلبك من موقعنا سوف يتم توصيل طلبك في اقرب وقت ممكن",
            printInvoice: "طباعة فاتورة",
            contact: "تواصل",
            home: "الرئيسية",
            returnToProduct: "العودة للمنتج",
            PageNotFound: "عذراً، الصفحة التي تبحث عنها غير موجودة",
            PageNotFoundDesc: "لم نتمكن من العثور على الصفحة التي تبحث عنها.",
            PaymentFailed: "فشلت عملية الدفع وتم انشاء طلبك بدفع عند الاستلام",
        },
    },
};
  